import React from 'react';
import { useAtomValue } from 'jotai';
import { Box } from '@mui/material';
import { ColumnFlexBox, CenteredFlexBox } from '../FlexBox';
import Logo from '../Logos/Logo';
import { themeAtom } from '../../Atoms';
import IconButton from '../Button/IconButton';
import CollapseSidebar from '../../assets/icons/CollapseSidebar';
import OpenSidebar from '../../assets/icons/OpenSidebar';
import BranchSelect from './BranchSelect';

const SidebarHeader = function SidebarHeader({
  open,
  toggleSidebar,
  handleSelectBranch,
}) {
  const themeMode = useAtomValue(themeAtom);

  return (
    <ColumnFlexBox padding="16px" gap="16px">
      <CenteredFlexBox>
        <Logo
          viewBox="0 0 1000 200"
          textColor={themeMode === 'light' ? '#1d1d1b' : '#fff'}
          logoColor={themeMode === 'dark' ? '#1d1d1b' : '#fff'}
        />
        <IconButton
          title={open ? 'COLLAPSE_SIDEBAR' : 'OPEN_SIDEBAR'}
          onClick={toggleSidebar}
          iconProps={{ sx: { padding: 'unset' } }}
        >
          {open ? <CollapseSidebar size={24} /> : <OpenSidebar size={24} />}
        </IconButton>
      </CenteredFlexBox>
      <Box
        sx={{
          visibility: open ? 'visible' : 'hidden',
          transition: 'visibility .3s',
        }}
      >
        <BranchSelect
          handleChangeBranch={handleSelectBranch}
          sidebarOpen={open}
        />
      </Box>
    </ColumnFlexBox>
  );
};

export default SidebarHeader;
